/* eslint-disable eag/no-css-property */
import {getCssSize, getValueByDevice, useDevice, VStack} from 'platform/foundation';
import {css} from 'styled-components';

import {RichContentDisplay} from '@chat/ui';

import {EventDate} from './EventDate';
import {Text} from './richContent/Text';

const AgentTopArrow = () => (
  <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4.47214V6H16L5.78885 0.894427C3.12925 -0.435375 0 1.49861 0 4.47214Z"
      fill="#D8DBFD"
      transform="translate(0, 2)"
    />
  </svg>
);

interface AgentMessageProps {
  message: string;
  createdAt: string;
  isRead?: boolean;
}

export function AgentMessage(props: AgentMessageProps) {
  const device = useDevice();
  const bubbleWidth = getValueByDevice(device, '260px', '560px', '260px', '260px');

  return (
    <VStack align="flex-start">
      <AgentTopArrow />
      <div
        css={css`
          width: ${bubbleWidth};
          background-color: ${({theme}) => theme.colors.accent.lighter};
          padding: ${getCssSize(3)};
          border-top-right-radius: ${getCssSize(2)};
          border-bottom-right-radius: ${getCssSize(2)};
          border-bottom-left-radius: ${getCssSize(2)};
          margin-bottom: ${getCssSize(1)};
        `}
      >
        <RichContentDisplay
          markdown={props.message}
          ContentEditableComponent={<Text type="agent" />}
        />
      </div>
      <EventDate timestamp={props.createdAt} isRead={props.isRead} isReadAfterText />
    </VStack>
  );
}
